import * as React from 'react'
import * as ReactDOM from 'react-dom'
import './ExpansionTrapezoid.css'

import * as _ from 'lodash'
import * as Model from 'src/types/document';
import { Stack } from 'src/types/stack';


class ExpansionTrapezoid extends React.Component<{
  callId: Model.CallId
  stack: Stack
}> {

  state = {
    ready: false,

    buttonBottom: 0,
    buttonLeft: 0,
    buttonWidth: 0,
    
    expansionTop: 0,
    expansionLeft: 0,
    expansionWidth: 0,
  }

  animationFrame = undefined as number | undefined

  render() {
    if (!this.state.ready) { return <div>nope</div> }
    const { buttonBottom, buttonLeft, buttonWidth, expansionTop, expansionLeft, expansionWidth } = this.state

    const xMin = Math.min(buttonLeft, expansionLeft)
    const xMax = Math.max(buttonLeft + buttonWidth, expansionLeft + expansionWidth)

    const width = xMax - xMin
    const height = expansionTop - buttonBottom

    const points = [
      [buttonLeft, buttonBottom],
      [buttonLeft + buttonWidth, buttonBottom],
      [expansionLeft + expansionWidth, expansionTop],
      [expansionLeft, expansionTop],
    ]

    return ReactDOM.createPortal(
      <svg className="ExpansionTrapezoid"
          style={{position: 'absolute', left: xMin, top: buttonBottom}}
          width={width} height={height}
          viewBox={`${xMin} ${buttonBottom} ${width} ${height}`} >
        <polygon className="ExpansionTrapezoid-trapezoid" points={_.flatten(points).join(' ')} />
      </svg>,
      window.document.body)
  }

  loop = () => {
    this.animationFrame = requestAnimationFrame(this.loop)

    const { callId, stack } = this.props
    const encodedStack = btoa(JSON.stringify(stack))
    const attributes = `[data-call='${callId}'][data-stack='${encodedStack}']`

    const button = document.querySelector('.Call-expansion-button' + attributes) as HTMLElement | undefined
    const expansion = document.querySelector('.Graph-expanded-call' + attributes) as HTMLElement | undefined

    if (button && expansion) {
      const bodyBox = document.body.getBoundingClientRect()
      const buttonBox = button.getBoundingClientRect()
      const expansionBox = expansion.getBoundingClientRect()

      const newState = {
        ready: true,
    
        buttonBottom: buttonBox.bottom - bodyBox.top,
        buttonLeft: buttonBox.left - bodyBox.left,
        buttonWidth: buttonBox.width,
        
        expansionTop: expansionBox.top - bodyBox.top,
        expansionLeft: expansionBox.left - bodyBox.left,
        expansionWidth: expansionBox.width,
      }

      if (!_.isEqual(this.state, newState)) {
        this.setState(newState)
      }
    }
  }

  componentDidMount() {
    this.loop()
  }

  componentWillUnmount() {
    if (this.animationFrame !== undefined) {
      cancelAnimationFrame(this.animationFrame)
    }
  }
}

export default ExpansionTrapezoid



// WEBPACK FOOTER //
// ./src/view/ExpansionTrapezoid.tsx